import { render, staticRenderFns } from "./HGoodList.vue?vue&type=template&id=ecdb0670&scoped=true&"
import script from "./HGoodList.vue?vue&type=script&lang=js&"
export * from "./HGoodList.vue?vue&type=script&lang=js&"
import style0 from "./HGoodList.vue?vue&type=style&index=0&id=ecdb0670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdb0670",
  null
  
)

export default component.exports